import React from "react";
import { Box, Typography, Card, CardContent, useTheme } from "@mui/material";

const StatCard = ({ title, value, icon }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={2}
      sx={{
        flex: 1,
        borderRadius: 2,
        background: theme.palette.background.paper,
      }}
    >
      <CardContent
        sx={{ p: 2, "&:last-child": { pb: 2 }, textAlign: "center" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 0.5,
          }}
        >
          {React.cloneElement(icon, {
            fontSize: "small",
            color: "primary",
            sx: { mr: 1 },
          })}
          <Typography variant="subtitle1" component="div">
            {title}
          </Typography>
        </Box>
        <Typography
          variant="h4"
          color="primary"
          fontWeight="bold"
          sx={{ mt: 0.5 }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatCard;
